/* Thème « Éclat » — scripts */
(function () {
  'use strict';
  document.documentElement.classList.add('js');
  var routes = window.themeRoutes || { root: '/', cartAdd: '/cart/add', cartChange: '/cart/change', cart: '/cart' };

  /* ---------- Panier latéral ---------- */
  var Drawer = {
    el: function () { return document.querySelector('[data-cart-drawer]'); },
    open: function () {
      var d = this.el();
      if (!d || typeof d.showModal !== 'function') return false;
      if (!d.open) d.showModal();
      document.documentElement.classList.add('drawer-open');
      return true;
    },
    close: function () {
      var d = this.el();
      if (d && d.open) d.close();
    },
    render: function (html) {
      var d = this.el();
      if (!d || !html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-drawer-inner]');
      var current = d.querySelector('[data-cart-drawer-inner]');
      if (fresh && current) current.replaceWith(fresh);
      var countEl = d.querySelector('[data-cart-count-value]');
      if (countEl) updateCount(parseInt(countEl.textContent, 10) || 0);
    },
    fetchSection: function () {
      var url = routes.root + (routes.root.indexOf('?') > -1 ? '&' : '?') + 'sections=cart-drawer';
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) { Drawer.render(data['cart-drawer']); });
    }
  };

  function updateCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function initDrawer() {
    var d = Drawer.el();
    if (!d) return;
    d.addEventListener('close', function () { document.documentElement.classList.remove('drawer-open'); });
    d.addEventListener('click', function (e) {
      if (e.target === d) { Drawer.close(); return; }
      if (e.target.closest('[data-drawer-close]')) { Drawer.close(); return; }
      var change = e.target.closest('[data-line][data-qty]');
      if (change) {
        e.preventDefault();
        changeLine(change.getAttribute('data-line'), change.getAttribute('data-qty'));
      }
    });
    document.querySelectorAll('[data-cart-toggle]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (Drawer.open()) e.preventDefault();
      });
    });
  }

  function changeLine(line, qty) {
    var inner = document.querySelector('[data-cart-drawer-inner]');
    if (inner) inner.setAttribute('aria-busy', 'true');
    fetch(routes.cartChange, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: Math.max(0, parseInt(qty, 10) || 0), sections: 'cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.sections && data.sections['cart-drawer']) Drawer.render(data.sections['cart-drawer']);
        else return Drawer.fetchSection();
      })
      .catch(function () { window.location.href = routes.cart; });
  }

  function initAjaxForms() {
    var drawer = Drawer.el();
    if (!drawer || window.fetch === undefined || typeof drawer.showModal !== 'function') return;
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.classList || !form.classList.contains('js-ajax-cart')) return;
      var submitter = e.submitter;
      if (submitter && submitter.name === 'checkout') return;
      e.preventDefault();

      var buttons = document.querySelectorAll('button[form="' + form.id + '"]');
      var all = Array.prototype.slice.call(form.querySelectorAll('[type="submit"]')).concat(Array.prototype.slice.call(buttons));
      all.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
      var errorEl = form.querySelector('[data-form-error]');
      if (errorEl) errorEl.hidden = true;

      var body = new FormData(form);
      body.append('sections', 'cart-drawer');
      body.append('sections_url', window.location.pathname);

      fetch(routes.cartAdd, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok || res.data.status) {
            var msg = (res.data && (res.data.description || res.data.message)) || 'Impossible d’ajouter ce bijou au panier.';
            if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; }
            else { window.alert(msg); }
            return;
          }
          if (res.data.sections && res.data.sections['cart-drawer']) Drawer.render(res.data.sections['cart-drawer']);
          else return Drawer.fetchSection().then(function () { Drawer.open(); });
          Drawer.open();
        })
        .catch(function () { form.submit(); })
        .finally(function () { all.forEach(function (b) { b.removeAttribute('aria-busy'); }); });
    });
  }

  /* ---------- Galerie ---------- */
  function initGallery(gallery) {
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-media-id]'));
    var thumbs = gallery.querySelectorAll('[data-thumb]');
    function currentIndex() {
      for (var i = 0; i < slides.length; i++) if (!slides[i].hidden) return i;
      return 0;
    }
    function show(id) {
      id = String(id);
      if (!slides.some(function (s) { return s.getAttribute('data-media-id') === id; })) return;
      slides.forEach(function (s) { s.hidden = s.getAttribute('data-media-id') !== id; });
      thumbs.forEach(function (t) {
        var on = t.getAttribute('data-thumb') === id;
        t.setAttribute('aria-current', on ? 'true' : 'false');
        if (on && t.scrollIntoView && t.parentElement.scrollWidth > t.parentElement.clientWidth) {
          t.parentElement.scrollTo({ left: t.offsetLeft - 20, behavior: 'smooth' });
        }
      });
    }
    function step(dir) {
      if (!slides.length) return;
      var i = (currentIndex() + dir + slides.length) % slides.length;
      show(slides[i].getAttribute('data-media-id'));
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-thumb')); }); });
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    /* Balayage sur mobile */
    var main = gallery.querySelector('.gallery__main');
    var startX = null;
    if (main && slides.length > 1) {
      main.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
        startX = null;
      });
    }
    return show;
  }

  /* ---------- Produit ---------- */
  function initProduct(root) {
    var gallery = root.querySelector('[data-gallery]');
    var showMedia = gallery ? initGallery(gallery) : function () {};
    var jsonEl = root.querySelector('[data-variants-json]');
    var variants = [];
    try { variants = jsonEl ? JSON.parse(jsonEl.textContent) : []; } catch (e) { variants = []; }

    var idInput = root.querySelector('[data-variant-id]');
    var fieldsets = root.querySelectorAll('[data-option-position]');

    function update() {
      var opts = Array.prototype.map.call(fieldsets, function (fs) {
        var checked = fs.querySelector('input:checked');
        var label = fs.querySelector('[data-option-selected]');
        if (checked && label) label.textContent = checked.value;
        return checked ? checked.value : null;
      });
      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });

      root.querySelectorAll('[data-add-button]').forEach(function (btn) {
        var addLabel = btn.getAttribute('data-label-add') || 'Ajouter au panier';
        if (!variant) { btn.disabled = true; btn.textContent = 'Indisponible'; }
        else if (!variant.available) { btn.disabled = true; btn.textContent = 'Épuisé'; }
        else { btn.disabled = false; btn.textContent = addLabel; }
      });
      root.querySelectorAll('[data-stock]').forEach(function (el) { el.hidden = !(variant && variant.available); });
      if (!variant) return;

      if (idInput) idInput.value = variant.id;
      root.querySelectorAll('[data-price]').forEach(function (el) {
        el.innerHTML = variant.price;
        el.classList.toggle('price--sale', !!variant.compare);
      });
      root.querySelectorAll('[data-compare-price]').forEach(function (el) {
        if (variant.compare) { el.innerHTML = variant.compare; el.hidden = false; } else { el.hidden = true; }
      });
      root.querySelectorAll('[data-sale-badge]').forEach(function (el) {
        if (variant.save) { el.textContent = '−' + variant.save + ' %'; el.hidden = false; } else { el.hidden = true; }
      });
      if (variant.media) showMedia(variant.media);

      if (root.getAttribute('data-update-url') === 'true' && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target && e.target.hasAttribute('data-option-input')) update();
    });

    /* Quantité */
    root.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentElement.querySelector('input');
        if (!input) return;
        var v = (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-qty-step'), 10);
        input.value = Math.max(1, v);
      });
    });

    /* Barre d'achat fixe */
    var sticky = root.querySelector('[data-sticky-atc]');
    var mainBuy = root.querySelector('[data-main-buy]');
    if (sticky && mainBuy && 'IntersectionObserver' in window) {
      document.body.classList.add('has-sticky-atc');
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var visible = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', visible);
        if (visible) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
      }).observe(mainBuy);
    }
  }

  /* ---------- Menu mobile ---------- */
  function initMenu(details) {
    document.addEventListener('click', function (e) {
      if (details.open && !details.contains(e.target)) details.open = false;
    });
    details.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && details.open) {
        details.open = false;
        var summary = details.querySelector('summary');
        if (summary) summary.focus();
      }
    });
  }

  /* ---------- Page panier ---------- */
  function initCartPage(form) {
    form.addEventListener('change', function (e) {
      if (e.target && e.target.hasAttribute('data-cart-qty')) {
        var hidden = document.createElement('input');
        hidden.type = 'hidden'; hidden.name = 'update'; hidden.value = '1';
        form.appendChild(hidden);
        form.submit();
      }
    });
  }

  /* ---------- Vidéo de la bannière ---------- */
  function initHeroVideos() {
    var wraps = document.querySelectorAll('[data-hero-video]');
    if (!wraps.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function sync() {
      wraps.forEach(function (wrap) {
        var v = wrap.querySelector('video');
        if (!v) return;
        v.muted = true;
        v.setAttribute('playsinline', '');
        v.removeAttribute('controls');
        var visible = wrap.offsetParent !== null;
        if (visible && !reduce) {
          v.preload = 'auto';
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }
    sync();
    var mq = window.matchMedia('(max-width: 749px)');
    if (mq.addEventListener) mq.addEventListener('change', sync);
  }

  function init() {
    initHeroVideos();
    initDrawer();
    initAjaxForms();
    document.querySelectorAll('[data-product]').forEach(initProduct);
    document.querySelectorAll('[data-menu-drawer]').forEach(initMenu);
    var cartForm = document.getElementById('cart-form');
    if (cartForm) initCartPage(cartForm);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
